import React from 'react';
import { useMutation } from '@tanstack/react-query';
import useSnackbar from '../../useSnackbar';
import { workPlanFiscalYearCreation } from 'services/reactQueryservices';
import { client } from '../../../react_query/query-client-configuration';
import { fiscalYearList } from 'react_query/query-keys';
const useWorkPlanFiscalYearCreation = () => {
    const { mutate, error, isSuccess, isError, isLoading } = useMutation({
        mutationFn: workPlanFiscalYearCreation,
        onSettled: (data, error) => {
            if (error) {
            } else {
                client.invalidateQueries({ queryKey: [fiscalYearList] });
            }
        }
    });
    return {
        mutate,
        error,
        isSuccess,
        isError,
        isLoading
    };
};

export default useWorkPlanFiscalYearCreation;
